var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["product-unavailable.j2"] = require( "product-unavailable.j2" );
dependencies["product-meta/title.j2"] = require( "product-meta/title.j2" );
dependencies["product-meta/price.j2"] = require( "product-meta/price.j2" );
dependencies["quickshop-product-unavailable.j2"] = require( "quickshop-product-unavailable.j2" );
dependencies["product-sold-out.j2"] = require( "product-sold-out.j2" );
dependencies["product-meta.j2"] = require( "product-meta.j2" );
dependencies["controls/product-controls-faceout.j2"] = require( "controls/product-controls-faceout.j2" );
dependencies["product-promo-exclusions.j2"] = require( "product-promo-exclusions.j2" );
dependencies["marketplace/marketplace-meta.j2"] = require( "marketplace/marketplace-meta.j2" );
dependencies["product-messages.j2"] = require( "product-messages.j2" );
dependencies["product-sku-actions-quickshop.j2"] = require( "product-sku-actions-quickshop.j2" );
dependencies["product-details.j2"] = require( "product-details.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/quickshop-body.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"c-product-container dom-quickshop-loader\">\n\n    <div class=\"o-row dom-main-product\n\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "innerProduct")),"isEgiftCard") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "innerProduct")),"isGiftCard")) {
output += " s-quickshop-gift-card ";
;
}
output += "\n\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"ownerView")) {
output += "\n\n            s-quickshop-owner\n\n        ";
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"shopperView")) {
output += "\n\n            s-quickshop-public\n\n        ";
;
}
;
}
output += "\n\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"showRegistryQuantity")) {
output += " s-registry-quickshop ";
;
}
output += "\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "wishlist")) {
output += " s-wishlist-quickshop ";
;
}
output += "\n\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"isSoldOut")) {
output += " s-quickshop-sold-out ";
;
}
output += "\n\n    HACK-ios-scroll\">\n\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productUnavailable") && !(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"ownerView") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"shopperView"))) {
output += "\n\n            ";
env.getTemplate("product-unavailable.j2", false, "product/templates/quickshop-body.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n\n        ";
})});
}
else {
output += "\n\n            <div class=\"o-row\">\n\n                <div class=\"o-row o-column o-extra-small--12 o-small--6\">\n\n                    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish")) {
output += "\n\n                        <div class=\"o-row\">\n\n                            <div class=\"s-product-meta o-column o-extra-small--12\">\n\n                                ";
env.getTemplate("product-meta/title.j2", false, "product/templates/quickshop-body.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n\n                                ";
env.getTemplate("product-meta/price.j2", false, "product/templates/quickshop-body.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
output += "\n\n                            </div>\n\n                        </div>\n\n                    ";
})})})});
}
output += "\n\n                    ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"imageViewerRender")), env.opts.autoescape);
output += "\n\n                </div>\n\n                <div class=\"c-quickshop__product-info--outer o-column o-extra-small--12 o-small--6\">\n\n                    <div class=\"c-quickshop__product-info\">\n\n                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productUnavailable")) {
output += "\n\n                            ";
env.getTemplate("quickshop-product-unavailable.j2", false, "product/templates/quickshop-body.j2", null, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
t_13.render(context.getVariables(), frame, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
output += t_14
output += "\n\n                        ";
})});
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"isSoldOut")) {
output += "\n\n                            ";
env.getTemplate("product-sold-out.j2", false, "product/templates/quickshop-body.j2", null, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
t_17.render(context.getVariables(), frame, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
output += t_18
output += "\n\n                        ";
})});
}
;
}
output += "\n\n                        ";
output += "\n                        <div class=\"o-row\">\n\n                            <div class=\"o-column o-extra-small--12\">\n\n                                ";
env.getTemplate("product-meta.j2", false, "product/templates/quickshop-body.j2", null, function(t_23,t_21) {
if(t_23) { cb(t_23); return; }
t_21.render(context.getVariables(), frame, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
output += t_22
output += "\n\n                            </div>\n\n                        </div>\n\n                        <form novalidate id=\"quickshop-add-form\" action=\"#\" method=\"post\" class=\"c-form js-product-add-form\">\n\n                            ";
output += "\n                            ";
env.getTemplate("controls/product-controls-faceout.j2", false, "product/templates/quickshop-body.j2", null, function(t_27,t_25) {
if(t_27) { cb(t_27); return; }
t_25.render(context.getVariables(), frame, function(t_28,t_26) {
if(t_28) { cb(t_28); return; }
output += t_26
output += "\n\n                            ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"isSoldOut") && !runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productUnavailable")) {
output += "\n\n                                ";
if(!(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"shopperView") && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"product")),"selectedSku")),"availabilityInfo")),"isOutOfStock"))) {
output += "\n\n                                    ";
env.getTemplate("product-promo-exclusions.j2", false, "product/templates/quickshop-body.j2", null, function(t_31,t_29) {
if(t_31) { cb(t_31); return; }
t_29.render(context.getVariables(), frame, function(t_32,t_30) {
if(t_32) { cb(t_32); return; }
output += t_30
output += "\n\n                                    ";
env.getTemplate("marketplace/marketplace-meta.j2", false, "product/templates/quickshop-body.j2", null, function(t_35,t_33) {
if(t_35) { cb(t_35); return; }
t_33.render(context.getVariables(), frame, function(t_36,t_34) {
if(t_36) { cb(t_36); return; }
output += t_34
output += "\n\n                                    ";
output += "\n                                    ";
env.getTemplate("product-messages.j2", false, "product/templates/quickshop-body.j2", null, function(t_39,t_37) {
if(t_39) { cb(t_39); return; }
t_37.render(context.getVariables(), frame, function(t_40,t_38) {
if(t_40) { cb(t_40); return; }
output += t_38
output += "\n\n                                ";
})})})})})});
}
output += "\n\n                            ";
;
}
output += "\n\n                            ";
output += "\n                            ";
env.getTemplate("product-sku-actions-quickshop.j2", false, "product/templates/quickshop-body.j2", null, function(t_43,t_41) {
if(t_43) { cb(t_43); return; }
t_41.render(context.getVariables(), frame, function(t_44,t_42) {
if(t_44) { cb(t_44); return; }
output += t_42
output += "\n\n                        </form>\n\n                    </div>\n\n                </div>\n\n            </div>\n\n            ";
output += "\n            ";
if(runtime.contextOrFrameLookup(context, frame, "productDetails")) {
output += "\n                ";
env.getTemplate("product-details.j2", false, "product/templates/quickshop-body.j2", null, function(t_47,t_45) {
if(t_47) { cb(t_47); return; }
t_45.render(context.getVariables(), frame, function(t_48,t_46) {
if(t_48) { cb(t_48); return; }
output += t_46
output += "\n            ";
})});
}
output += "\n\n        ";
})})})})})});
}
output += "\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/quickshop-body.j2"] , dependencies)